'use strict';

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _wrapNativeSuper = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapNativeSuper");

var NonFatalError =
/*#__PURE__*/
function (_Error) {
  _inherits(NonFatalError, _Error);

  function NonFatalError(message) {
    var _this;

    _classCallCheck(this, NonFatalError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(NonFatalError).call(this, message));
    _this.code = 0;
    return _this;
  }

  return NonFatalError;
}(_wrapNativeSuper(Error));

var FatalError =
/*#__PURE__*/
function (_Error2) {
  _inherits(FatalError, _Error2);

  function FatalError(message) {
    var _this2;

    _classCallCheck(this, FatalError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(FatalError).call(this, message));
    _this2.code = 1;
    return _this2;
  }

  return FatalError;
}(_wrapNativeSuper(Error));

module.exports = {
  NonFatalError: NonFatalError,
  FatalError: FatalError
};